export default __webpack_public_path__ + "static/media/Pot2.d31f67c1.svg";